import { format } from 'date-fns'
import dayjs from 'dayjs'

export function formatDate(s) {
  const date = new Date()
  if (s && typeof s === 'string') {
    const data = s.split('-')
    if (data?.[0]) {
      date.setFullYear(parseInt(data[0]))
    }
    if (data?.[1]) {
      date.setMonth(parseInt(data[1]) - 1)
    }
    if (data?.[2]) {
      date.setDate(parseInt(data[2]))
    }
    return format(date, 'dd.MM.yyyy')
  }
}

export const getDateOnly = (isoString) => {
  if (!isoString) return null
  const dateOnly = isoString.split('T')[0]
  return dayjs(dateOnly).format('YYYY-MM-DD')
}
